import { render, staticRenderFns } from "./StudentBookings.vue?vue&type=template&id=584e1730&scoped=true"
import script from "./StudentBookings.vue?vue&type=script&lang=js"
export * from "./StudentBookings.vue?vue&type=script&lang=js"
import style0 from "./StudentBookings.vue?vue&type=style&index=0&id=584e1730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584e1730",
  null
  
)

export default component.exports